module.exports = "/static/assets/3d97c0d2dd797f00c614c9c7bdde2850.png";